<template>
  <div class="form-info">

    <el-form :model="formData" :rules="passportRules" ref="passportForm" label-width="90px" :class="['info-rule-form', readOnly ? 'read-only' : '']" v-if="type === 'passport'">
      <el-form-item prop="surname_cn" class="marginBottom20">
        <span slot="label" class="label-box">姓（中文）</span>
        <el-input v-model="formData.surname_cn" :maxlength="surnameCnLength" placeholder="请填写姓（中文）" v-if="!readOnly" @change="stringTrim($event, 'surname_cn')"></el-input>
        <span class="read-only-box" v-else>{{formData.surname_cn}}</span>
      </el-form-item>

      <el-form-item prop="name_cn" class="marginBottom20">
        <span slot="label" class="label-box">名（中文）</span>
        <el-input v-model="formData.name_cn" :maxlength="nameCnLength" placeholder="请填写名（中文）" v-if="!readOnly" @change="stringTrim($event, 'name_cn')"></el-input>
        <span class="read-only-box" v-else>{{formData.name_cn}}</span>
      </el-form-item>

      <el-form-item prop="surname_pinyin" class="marginBottom20">
        <span slot="label" class="label-box">姓（拼音）</span>
        <el-input v-model="formData.surname_pinyin" :maxlength="40" placeholder="请填写姓（拼音）" v-if="!readOnly" @change="stringTrim($event, 'surname_pinyin')"></el-input>
        <span class="read-only-box" v-else>{{formData.surname_pinyin}}</span>
      </el-form-item>

      <el-form-item prop="name_pinyin" class="marginBottom20">
        <span slot="label" class="label-box">名（拼音）</span>
        <el-input v-model="formData.name_pinyin" :maxlength="60" placeholder="请填写名（拼音）" v-if="!readOnly" @change="stringTrim($event, 'name_pinyin')"></el-input>
        <span class="read-only-box" v-else>{{formData.name_pinyin}}</span>
      </el-form-item>

      <el-form-item prop="gender" class="marginBottom20">
        <span slot="label" class="label-box">性别</span>
        <el-radio-group v-model="formData.gender" v-if="!readOnly">
          <el-radio :label="0">男</el-radio>
          <el-radio :label="1">女</el-radio>
        </el-radio-group>
        <span class="read-only-box" v-else>{{formData.gender | getGender}}</span>
      </el-form-item>

      <el-form-item prop="birthday" class="marginBottom20">
        <span slot="label" class="label-box">出生日期</span>
        <el-date-picker
          v-model="formData.birthday"
          type="date"
          placeholder="选择出生日期"
          v-if="!readOnly">
        </el-date-picker>
        <span class="read-only-box" v-else>{{formData.birthday}}</span>
      </el-form-item>

      <el-form-item prop="passport_number" class="marginBottom20">
        <span slot="label" class="label-box">护照号码</span>
        <el-input v-model="formData.passport_number" :maxlength="12" placeholder="请填写护照号码" v-if="!readOnly" @change="stringTrim($event, 'passport_number')"></el-input>
        <span class="read-only-box" v-else>{{formData.passport_number}}</span>
      </el-form-item>

      <el-form-item prop="issue_date" class="marginBottom20">
        <span slot="label" class="label-box">签发日期</span>
        <el-date-picker
          v-model="formData.issue_date"
          type="date"
          placeholder="选择签发日期"
          v-if="!readOnly">
        </el-date-picker>
        <span class="read-only-box" v-else>{{formData.issue_date}}</span>
      </el-form-item>

      <el-form-item prop="expire_date" class="marginBottom20">
        <span slot="label" class="label-box">有效期至</span>
        <el-date-picker
          v-model="formData.expire_date"
          type="date"
          placeholder="选择日期"
          v-if="!readOnly">
        </el-date-picker>
        <span class="read-only-box" v-else>{{formData.expire_date}}</span>
      </el-form-item>

      <el-form-item prop="birth_place_cn" class="marginBottom20">
        <span slot="label" class="label-box">出生地点</span>
        <el-select v-model="formData.birth_place_cn" placeholder="请选择出生地点" v-if="!readOnly">
          <el-option
            v-for="item in provinces"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <span class="read-only-box" v-else>{{formData.birth_place_cn}}</span>
      </el-form-item>

      <el-form-item prop="other_birth_place_cn" v-if="isOtherBirthCn" class="marginBottom20">
        <span slot="label" class="label-box other_label-box">其它出生地点</span>
        <el-input v-model.trim="formData.other_birth_place_cn" :maxlength="10" placeholder="请填写其它出生地点" v-if="!readOnly"></el-input>
        <span class="read-only-box" v-else>{{formData.other_birth_place_cn}}</span>
      </el-form-item>

      <el-form-item prop="birth_place_pinyin" class="marginBottom20">
        <span slot="label" class="label-box">出生地点英文</span>
        <el-select v-model="formData.birth_place_pinyin" placeholder="请选择出生地点（英文）" v-if="!readOnly">
          <el-option
            v-for="item in provincesPinyin"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <span class="read-only-box" v-else>{{formData.birth_place_pinyin}}</span>
      </el-form-item>

      <el-form-item prop="other_birth_place_pinyin" v-if="isOtherBirthEn" class="marginBottom20">
        <span slot="label" class="label-box other_label-box">其它出生地点英文</span>
        <el-input v-model.trim="formData.other_birth_place_pinyin" :maxlength="20" placeholder="请填写其它出生地点英文" v-if="!readOnly"></el-input>
        <span class="read-only-box" v-else>{{formData.other_birth_place_pinyin}}</span>
      </el-form-item>

      <el-form-item prop="issue_place_cn" class="marginBottom20">
        <span slot="label" class="label-box">签发地点</span>
        <el-select v-model="formData.issue_place_cn" placeholder="请选择其它签发地点" v-if="!readOnly">
          <el-option
            v-for="item in provinces"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <span class="read-only-box" v-else>{{formData.issue_place_cn}}</span>
      </el-form-item>

      <el-form-item prop="other_issue_place_cn" v-if="isOtherIssueCn" class="marginBottom20">
        <span slot="label" class="label-box other_label-box">其它签发地点</span>
        <el-input v-model="formData.other_issue_place_cn" :maxlength="10" placeholder="请填写其它签发地点" v-if="!readOnly" @change="stringTrim($event, 'other_issue_place_cn')"></el-input>
        <span class="read-only-box" v-else>{{formData.other_issue_place_cn}}</span>
      </el-form-item>

      <el-form-item prop="issue_place_pinyin" class="marginBottom20">
        <span slot="label" class="label-box">签发地点英文</span>
        <el-select v-model="formData.issue_place_pinyin" placeholder="请选择签发地点（英文）" v-if="!readOnly">
          <el-option
            v-for="item in provincesPinyin"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <span class="read-only-box" v-else>{{formData.issue_place_pinyin}}</span>
      </el-form-item>

      <el-form-item prop="other_issue_place_pinyin" v-if="isOtherIssueEn" class="marginBottom20">
        <span slot="label" class="label-box other_label-box">其它签发地点英文</span>
        <el-input v-model="formData.other_issue_place_pinyin" :maxlength="20" placeholder="请填写签发地点" v-if="!readOnly" @change="stringTrim($event, 'other_issue_place_pinyin')"></el-input>
        <span class="read-only-box" v-else>{{formData.other_issue_place_pinyin}}</span>
      </el-form-item>

      <el-form-item prop="issue_authority_cn" class="marginBottom20">
        <span slot="label" class="label-box">签发机关</span>
        <el-input v-model="formData.issue_authority_cn" :maxlength="30" placeholder="请填写签发机关" v-if="!readOnly" @change="stringTrim($event, 'issue_authority_cn')"></el-input>
        <span class="read-only-box" v-else>{{formData.issue_authority_cn}}</span>
      </el-form-item>

      <el-form-item prop="issue_authority_en" class="marginBottom20">
        <span slot="label" class="label-box">签发机关英文</span>
        <el-input v-model="formData.issue_authority_en" :maxlength="100" placeholder="请填写签发机关英文" v-if="!readOnly" @change="stringTrim($event, 'issue_authority_en')"></el-input>
        <span class="read-only-box" v-else>{{formData.issue_authority_en}}</span>
      </el-form-item>
    </el-form>

    <el-form :model="formData" :rules="idcardaRules" ref="idcardaForm" label-width="90px" v-if="type === 'idcarda'" :class="[readOnly ? 'read-only' : '']">
      <el-form-item prop="fullname">
        <span slot="label" class="label-box">姓名（中文）</span>
        <el-input v-model="formData.fullname" :maxlength="15" placeholder="请填写姓名（中文）" v-if="!readOnly" @change="stringTrim($event, 'fullname')"></el-input>
        <span class="read-only-box" v-else>{{formData.fullname}}</span>
      </el-form-item>

      <el-form-item  prop="id_no">
        <span slot="label" class="label-box">身份证号码</span>
        <el-input v-model="formData.id_no" :maxlength="18" placeholder="请填写身份证号码" v-if="!readOnly" @change="stringTrim($event, 'id_no')"></el-input>
        <span class="read-only-box" v-else>{{formData.id_no}}</span>
      </el-form-item>

      <el-form-item prop="gender">
        <span slot="label" class="label-box">性别</span>
        <el-radio-group v-model="formData.gender" v-if="!readOnly">
          <el-radio :label="0">男</el-radio>
          <el-radio :label="1">女</el-radio>
        </el-radio-group>
        <span class="read-only-box" v-else>{{formData.gender | getGender}}</span>
      </el-form-item>

      <el-form-item prop="nation">
        <span slot="label" class="label-box">民族</span>
        <el-select v-model="formData.nation" placeholder="请选择民族" v-if="!readOnly">
          <el-option
            v-for="item in nations"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <span class="read-only-box" v-else>{{formData.nation}}</span>
      </el-form-item>

      <el-form-item prop="birthday">
        <span slot="label" class="label-box">出生日期</span>
        <el-date-picker
          v-model="formData.birthday"
          type="date"
          placeholder="选择出生日期"
          v-if="!readOnly">
        </el-date-picker>
        <span class="read-only-box" v-else>{{formData.birthday}}</span>
      </el-form-item>

      <el-form-item prop="address">
        <span slot="label" class="label-box">住址</span>
        <el-input v-model="formData.address" :maxlength="50" placeholder="请填写住址" v-if="!readOnly" @change="stringTrim($event, 'address')"></el-input>
        <span class="read-only-box" v-else>{{formData.address}}</span>
      </el-form-item>
    </el-form>

    <el-form :model="formData" :rules="idcardbRules" ref="idcardbForm" label-width="90px" v-if="type === 'idcardb'" :class="[readOnly ? 'read-only' : '']">
      <el-form-item prop="issue_authority">
        <span slot="label" class="label-box">签发机关</span>
        <el-input v-model="formData.issue_authority" :maxlength="20" placeholder="请填写签发机关" v-if="!readOnly" @change="stringTrim($event, 'issue_authority')"></el-input>
        <span class="read-only-box" v-else>{{formData.issue_authority}}</span>
      </el-form-item>

      <el-form-item prop="issue_date">
        <span slot="label" class="label-box">签发日期</span>
        <el-date-picker
          v-model="formData.issue_date"
          type="date"
          placeholder="选择签发日期"
          v-if="!readOnly">
        </el-date-picker>
        <span class="read-only-box" v-else>{{formData.issue_date}}</span>
      </el-form-item>

      <el-form-item prop="expire_date" class="idcardb-expire-date">
        <span slot="label" class="label-box">有效期至</span>
        <template v-if="!readOnly">
          <el-date-picker
            v-model="formData.expire_date"
            type="date"
            placeholder="选择日期"
            v-show="!idcardbExpireDate">
          </el-date-picker>

          <el-input placeholder="长期" :disabled="idcardbExpireDate" v-show="idcardbExpireDate"></el-input>
        </template>
        <span class="read-only-box" v-else>{{formData.expire_date | longTermfilter}}</span>
      </el-form-item>

      <el-checkbox v-model="idcardbExpireDate" class="long-term-effective" @change='longTermEffective' v-if="!readOnly">长期有效</el-checkbox>

    </el-form>

    <div class="btn-box" v-if="showCancel || showSave">
      <el-button class="upload-replace btn" @click="uploadAgain" :loading="btnLoading" v-if="showCancel">{{cancelText}}</el-button>
      <el-button class="btn" type="primary" @click="saveInfo" :loading="btnLoading" v-if="showSave">保存</el-button>
    </div>
  </div>
</template>

<script>
import PROVINCES from '@/constants/provinces-constants';
import PROVINCES_PINYIN from '@/constants/provinces-pinyin-constants';
import NATIONS from '@/constants/nations-constants';
import Http from '@/libs/http';
import rules from './rules.js';

const provinces = PROVINCES.map(province => ({ label: province, value: province }));
const provincesPinyin = PROVINCES_PINYIN.map(province => ({ label: province, value: province }));
const nations = NATIONS.map(nation => ({ label: nation, value: nation }));

export default {
  name: 'form-info',
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      required: true,
      default: '',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: Number,
      required: true,
    },
    applicantId: {
      type: Number,
      required: true,
    },
    currentMaterial: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    cancelText: {
      type: String,
      default: '重新上传',
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    showSave: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isOtherIssueCn() {
      if (this.formData.issue_place_cn === '其它') return true;
      return false;
    },
    isOtherIssueEn() {
      if (this.formData.issue_place_pinyin === 'OTHER') return true;
      return false;
    },
    isOtherBirthCn() {
      if (this.formData.birth_place_cn === '其它') return true;
      return false;
    },
    isOtherBirthEn() {
      if (this.formData.birth_place_pinyin === 'OTHER') return true;
      return false;
    },
    surnameCnLength() {
      return 15 - this.formData.name_cn.length;
    },
    nameCnLength() {
      return 15 - this.formData.surname_cn.length;
    },
  },
  data() {

    return {
      provinces,
      provincesPinyin,
      nations,
      passportRules: rules.passportRules,
      idcardaRules: rules.idcardaRules,
      idcardbRules: rules.idcardbRules,

      idcardbExpireDate: false,
      btnLoading: false,
    };
  },
  filters: {
    getGender(val) {
      if (val === 0) return '男';
      if (val === 1) return '女';
      if (val === -1) return '';
    },
    longTermfilter(val) {
      if (val === '3000-01-01') {
        return '长期';
      }
      return val;
    },
  },
  methods: {
    // 长期有效
    longTermEffective() {
      if (this.idcardbExpireDate && this.type === 'idcardb') this.formData.expire_date = '3000-01-01';
      if (!this.idcardbExpireDate && this.type === 'idcardb') this.formData.expire_date = '';
    },
    // 如果是其它地区的 修改一下出生地点和签发地点的显示方式
    saveOtherPlace() {

      const issue_place_index = PROVINCES.indexOf(this.formData.issue_place_cn);
      const issue_place_pinyin_index = PROVINCES_PINYIN.indexOf(this.formData.issue_place_pinyin);

      const birth_place_index = PROVINCES.indexOf(this.formData.birth_place_cn);
      const birth_place_pinyin_index = PROVINCES_PINYIN.indexOf(this.formData.birth_place_pinyin);

      if (issue_place_index === -1 && this.formData.issue_place_cn) {
        this.formData.other_issue_place_cn = this.formData.issue_place_cn;
        this.formData.issue_place_cn = '其它';
      }
      if (issue_place_pinyin_index === -1 && this.formData.issue_place_pinyin) {
        this.formData.other_issue_place_pinyin = this.formData.issue_place_pinyin;
        this.formData.issue_place_pinyin = 'OTHER';
      }

      if (birth_place_index === -1 && this.formData.birth_place_cn) {
        this.formData.other_birth_place_cn = this.formData.birth_place_cn;
        this.formData.birth_place_cn = '其它';
      }
      if (birth_place_pinyin_index === -1 && this.formData.birth_place_pinyin) {
        this.formData.other_birth_place_pinyin = this.formData.birth_place_pinyin;
        this.formData.birth_place_pinyin = 'OTHER';
      }
    },
    // 同步省份
    syncProvinces(newVal, oldVal, type, changeKey) {
      const selfProvinceList = type === 'cn' ? PROVINCES : PROVINCES_PINYIN;
      const changeProvinceList = type === 'cn' ? PROVINCES_PINYIN : PROVINCES;
      // 同步省份必须在nextTick中，不然会造成数据为空的情况
      this.$nextTick(() => {
        const index = selfProvinceList.indexOf(newVal);
        const old_index = selfProvinceList.indexOf(oldVal);
        if (newVal !== oldVal && old_index !== -1 && index !== -1) {
          this.formData[changeKey] = changeProvinceList[index];
        }
      });
    },
    // 保存提交
    saveInfo() {
      const formName = `${this.type}Form`;

      // 检查必备字段并且弹出弹窗
      if (!this.checkValidForNeed()) {
        this.$message.error('内容不正确，请检查标红部分');
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          const submitData = JSON.parse(JSON.stringify(this.formData));
          if (this.type === 'passport') {
            if (submitData.issue_place_cn === '其它') {
              submitData.issue_place_cn = submitData.other_issue_place_cn;
            }
            if (submitData.issue_place_pinyin === 'OTHER') {
              submitData.issue_place_pinyin = submitData.other_issue_place_pinyin;
            }
            if (submitData.birth_place_cn === '其它') {
              submitData.birth_place_cn = submitData.other_birth_place_cn;
            }
            if (submitData.birth_place_pinyin === 'OTHER') {
              submitData.birth_place_pinyin = submitData.other_birth_place_pinyin;
            }
            submitData.fullname = submitData.surname_cn + submitData.name_cn;
            delete submitData.other_issue_place_cn;
            delete submitData.other_issue_place_pinyin;
            delete submitData.other_birth_place_cn;
            delete submitData.other_birth_place_pinyin;
            delete submitData.passport_type;
            delete submitData.img;
          } else if (this.type === 'idcarda') {
            delete submitData.issue_authority;
            delete submitData.issue_date;
            delete submitData.expire_date;
            delete submitData.back_img;
            delete submitData.front_img;
          } else if (this.type === 'idcardb') {
            delete submitData.fullname;
            delete submitData.id_no;
            delete submitData.gender;
            delete submitData.nation;
            delete submitData.birthday;
            delete submitData.address;
            delete submitData.back_img;
            delete submitData.front_img;
          }

          const submitUrl = {
            passport: '/applicant_passport_submit',
            idcarda: '/applicant_id_card_front_submit',
            idcardb: '/applicant_id_card_back_submit',
          };

          this.btnLoading = true;
          Http.post(submitUrl[this.type], {
            order_applicant_id: this.applicantId,
            ...submitData,
          })
            .then(() => {
              this.btnLoading = false;
              this.$emit('updateOrder');
              // 这里要先关掉弹窗之后才弹出提示，不然提示会被另一个弹窗挡住
              Promise.resolve(this.$emit('closeModal'))
                .then(() => {
                  this.$emit('successTips');
                }).catch((e) => {
                  if (e) console.log(e);
                });
            })
            .catch((e) => {
              if (e) console.log(e);
              this.btnLoading = false;
            });
        }
      });
    },
    // 重新上传
    uploadAgain() {
      this.$emit('closeModal');
      this.$parent.$parent.$parent.$parent.chooseFileAgain();
    },
    stringTrim(value, key) {
      this.$nextTick(() => {
        this.formData[key] = value.trim();
      });
    },
    // 检查各字段
    checkValid() {
      const formName = `${this.type}Form`;
      this.$refs[formName].validate();
    },
    // 检查必备字段并且弹出toast
    checkValidForNeed() {
      const rules = JSON.parse(JSON.stringify(this[`${this.type}Rules`]));
      const formName = `${this.type}Form`;

      // 如果是护照且没有其它省份出现时，不需要检查这个字段
      if (this.type === 'passport') {
        if (!this.isOtherIssueCn) delete rules.other_issue_place_cn;
        if (!this.isOtherIssueEn) delete rules.other_issue_place_pinyin;
        if (!this.isOtherBirthCn) delete rules.other_birth_place_cn;
        if (!this.isOtherBirthEn) delete rules.other_birth_place_pinyin;
      }

      const checkResult = Object.keys(rules).some((key) => {
        let errMsg;
        this.$refs[formName].validateField(key, (err) => {
          errMsg = err;
        });

        return errMsg;
      });
      return !checkResult;
    },
  },
  watch: {
    formData: {
      handler(newVal) {
        // 格式化护照信息日期
        const date_list = [
          'birthday',
          'issue_date',
          'expire_date',
        ];
        date_list.forEach((result) => {
          if (typeof newVal[result] === 'object' && newVal[result] instanceof Date) {
            newVal[result] = this.$service.dateService.formatDate(newVal[result]);
          }
        });

        // 拼音大写
        const pinyin_list = [
          'surname_pinyin',
          'name_pinyin',
        ];
        pinyin_list.forEach((result) => {
          if (typeof newVal[result] === 'string') {
            newVal[result] = newVal[result].toUpperCase();
          }
        });

        // 身份证长期有效的情况
        if (this.type === 'idcardb') {
          if (newVal.expire_date === '3000-01-01') this.idcardbExpireDate = true;
          else this.idcardbExpireDate = false;
        }

      },
      deep: true,
    },
    // 同步省份
    'formData.issue_place_cn': function (newVal, oldVal) {
      this.syncProvinces(newVal, oldVal, 'cn', 'issue_place_pinyin');
    },
    'formData.issue_place_pinyin': function (newVal, oldVal) {
      this.syncProvinces(newVal, oldVal, 'en', 'issue_place_cn');
    },
    'formData.birth_place_cn': function (newVal, oldVal) {
      this.syncProvinces(newVal, oldVal, 'cn', 'birth_place_pinyin');
    },
    'formData.birth_place_pinyin': function (newVal, oldVal) {
      this.syncProvinces(newVal, oldVal, 'en', 'birth_place_cn');
    },
  },
};
</script>

<style lang="less" scoped>
div.form-info {
  div.btn-box{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 54px;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #ffffff;
    opacity: 0.9;
    border-left: 1px solid #f0f0f0;
    .btn{
      width: 120px;
      height: 34px;
      font-size: 14px;
      border-radius: 4px;
    }
    .upload-replace{
      border: solid 1px #5e9be1;
      color: #5e9be1;
    }
  }
}
</style>

<style lang="less">
div.form-info{
  .el-form{
    .el-form-item{
      margin-bottom: 20px;
      &.marginBottom20{
        margin-bottom: 10px;
      }
      &.is-error{
        margin-bottom: 30px;
      }
      .el-form-item__label{
        text-align: left;
        padding: 11px 0px 11px 0;
        color: #777777;
        position: relative;
        .other_label-box{
          position: absolute;
          top: 10px;
        }
      }
      .el-form-item__content{
        .el-form-item__error{
          color: #ff5a60;
        }
        .el-input__inner{
          color: #333333;
          font-size: 14px;
        }
        .el-date-editor.el-input{
          width: 100%;
        }
        .read-only-box{
          padding-left: 20px;
            font-size: 14px;
            font-weight: 600;
            color: #333333;
            display: inline-block;
        }
        .el-select{
          width: 100%;
        }
      }
      &.is-error{
        .el-form-item__label{
          .label-box{
            color: #ff5a60;
          }
        }
        .el-form-item__content{
          .el-input__inner{
            border-color: #ff5a60;
          }
        }
      }
    }

    &.read-only{
      .el-form-item{
        margin-bottom: 0px;
      }
    }

    .is-required{
      .el-form-item__label{
        &:before{
          content: '';
          margin-right: 0px;
        }
      }
    }

    .idcardb-expire-date{
      margin-bottom: 20px;
    }

    .long-term-effective{
      padding-left: 90px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/modals/idcard-passport-info-modal/form-info.vue